import React from 'react';
import { useModal } from '../contexts';
import { XIcon } from '@heroicons/react/outline';

function Modal(props: { children: React.ReactNode, preventClose?: boolean, onClose?: () => void; }) {

  const { closeModal } = useModal();

  return (
    <div className="absolute top-0 left-0 w-screen h-screen z-50 backdrop-filter backdrop-blur-sm" style={{ backgroundColor: "rgba(1, 1, 1, 0.3)" }}>
      <div className="absolute top-1/2 left-1/2 p-8 bg-white rounded-lg shadow-xl" style={{ transform: "translate(-50%, -50%)" }}>
        {!props.preventClose &&
          <XIcon className="absolute top-2 right-2 w-6 h-6 text-gray-500 cursor-pointer z-50" onClick={() => closeModal(props.onClose)} />
        }
        {props.children}
      </div>
    </div>
  );
};

export default Modal;
